module.exports = __webpack_public_path__ + "img/187-07232c.png";